import { EventType, LogLevel } from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
import jwt_decode from "jwt-decode";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

export const msalConfig = {
    auth: {
        ...window.config.auth
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: isIE || isEdge || isFirefox,
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

export const loginRequest = {
    scopes: ["openid", "profile", "offline_access"]
};

export const acquireAccessToken = async () => {
    const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
    if (!activeAccount) {
        msalInstance.loginRedirect(loginRequest);
    }

    const request = {
        ...loginRequest,
        account: activeAccount
    };

    const authResult = await msalInstance.acquireTokenSilent(request)
        .catch(() => msalInstance.loginRedirect(loginRequest));

    return authResult.accessToken
};

export const getUserRoles = async () => {
    const accessToken = await acquireAccessToken(); 

    if (accessToken) {
        const decoded = jwt_decode(accessToken);
        return decoded?.roles;
    }
    return null;
};